export const getBrowserLanguageKey = () => window.navigator.language

export const prepareLanguageKey = key => key.substr(0, 2)

export const getPreferredBrowserLanguageKeys = () => window.navigator.languages
